module.exports = __webpack_public_path__ + "static/img/maricologo.31e6930.svg";